import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

/**
 * CTRL_69 : Validation du champ "Modalités de financement"
 *
 * Règle BOAMP : Le champ doit être soit vide (0 caractères),
 * soit contenir entre 5 et 2000 caractères alphanumériques.
 */
export class CTRL_69 implements Validator {

    public static id = 'CTRL_69';
    private message = 'error.ctr_69';

    public LOG: LogService = new LogService(CTRL_69);

    validate(form: any, map) {

        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_69.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                if (!ctrl || !ctrl.value || !ctrl.value.rgCtrls) {
                    continue;
                }
                const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const firstCtrl = form.controls[firstWithStepId];

                // Récupérer la valeur du champ de manière sécurisée
                let trimmedValue = '';
                if (firstCtrl && firstCtrl.value != null) {
                    const value = firstCtrl.value;
                    trimmedValue = typeof value === 'string' ? value.trim() : String(value).trim();
                }

                const length = trimmedValue.length;
                const alphanumericCount = (trimmedValue.match(/[0-9A-Za-z]/g) || []).length;

                // Règle BOAMP : soit 0 caractères, soit entre 5 et 2000 caractères avec au moins 5 alphanumériques
                if (length === 0) {
                    // Champ vide : valide
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else if (length < 5 || alphanumericCount < 5) {
                    // Moins de 5 caractères ou moins de 5 alphanumériques : invalide
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else if (length > 2000) {
                    // Plus de 2000 caractères : invalide
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    // Entre 5 et 2000 caractères avec au moins 5 alphanumériques : valide
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}

